import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { MessageProvider } from '@trileuco/triskel-react-ui/components/i18n'
import { useGenerateBookablePath } from 'modules/bookables/routes'
import BookablesCarousel from 'components/bookable/BookableCarousel/BookablesCarousel'
import BookablesList from 'components/bookable/BookablesList/BookablesList'
import { useGetBookables, LoadingResults } from 'components/api'
import { useMediaQuery } from 'react-responsive'
import { DesktopBreakpoint } from 'components/layout/Mediaqueries'

const ListWidget = ({ id, referrer }) => {
  const { bookables, loading } = useGetBookables({
    queryParams: {
      ids: id
    }
  })

  const generateBookablePath = useGenerateBookablePath()
  const handleBookableClick = useCallback(
    (bookable) => {
      const bookableUrl = `${generateBookablePath(
        bookable
      )}?referrer=${referrer}`
      window.open(bookableUrl, '_blank')
    },
    [referrer, generateBookablePath]
  )

  const isDesktop = useMediaQuery(DesktopBreakpoint)

  if (loading) {
    return <LoadingResults />
  }

  return (
    <MessageProvider scope="bookableDetailsPage">
      {isDesktop ? (
        <BookablesCarousel
          onBookableClick={handleBookableClick}
          bookables={bookables}
        />
      ) : (
        <BookablesList
          onBookableClick={handleBookableClick}
          bookables={bookables}
        />
      )}
    </MessageProvider>
  )
}

ListWidget.propTypes = {
  id: PropTypes.string,
  host: PropTypes.string,
  referrer: PropTypes.string
}

ListWidget.displayName = 'ListWidget'

export default ListWidget
